import StickyProgress from './StickyProgress';
import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.binder(Hooks.StickyProgressRoot, StickyProgress);
